<mat-card class="top-card upper-space mat-elevation-z0">
  <div
    *ngIf="!client && !projectHasIPBoard"
    [class.collapsed]="isCollapsed"
    class="section-header padding d-flex justify-content-between padding overflowHidden clickable bottom-space"
    (click)="isCollapsed = !isCollapsed"
    [attr.aria-expanded]="!isCollapsed"
  >
    <div class="projectTitle flexer">Algemeen</div>

    <button
      mat-icon-button
      class="arrow-button pull-right"
      style="margin-top:5px"
    >
      <mat-icon svgIcon="arrow-up"></mat-icon>
    </button>
  </div>
  <div [collapse]="isCollapsed && !client" [isAnimated]="!safari && !client">
    <div *ngIf="!fromOldSystem" class="mb-4 pb-2">
      <div class="form-title">
        <div class="form-title-text">
          Info voor de installateur
        </div>
      </div>

      <textarea-input
        [placeholder]="
          'Info omtrent de plaatsing - waar plaatsen we het' +
          (projectHasIPBoard ? ' bord' : ' project')
        "
        [initContent]="inputSubProject.projectPlacement.extraPlacementInfo"
        [disabled]="disabled"
        [client]="true"
        (answer)="extraPlacementInfoChange($event)"
      ></textarea-input>

      <file-picker
        [inputProjectPlacement]="inputSubProject.projectPlacement"
        [formSection]="'sitePhotos'"
        [uploadButtonLabel]="'Foto locatie plaatsing'"
        [client]="client"
        [disabled]="disabled"
        (answer)="onSitePhotoUpload()"
        (assetDeleted)="onSitePhotoDeleted()"
        class="box-file-picker"
      ></file-picker>
    </div>

    <div class="upper-space">
      <div *ngIf="inputSubProject.projectPlacement">
        <div class="form-title">
          <div class="d-flex form-title-text">
            Adresgegevens
            <a
              *ngIf="showGoogleMapsButton"
              href="https://www.google.com/maps/search/{{
                inputSubProject.projectPlacement.address.line1
                  | googleMapsAddressRequest
                    : inputSubProject.projectPlacement.address.city
                    : inputSubProject.projectPlacement.address.postalCode
                    : inputSubProject.projectPlacement.address.country
              }}"
              target="_blank"
              class="clickable-map google-maps-button"
              ><mat-icon fontSet="fa" fontIcon="fa-map-marked-alt"></mat-icon
            ></a>
          </div>
        </div>

        <ng-container *ngIf="client">
          <checkbox
            [text]="'Onbekend adres'"
            (answer)="unknownAddressChanged($event)"
          ></checkbox>
        </ng-container>

        <div
          *ngIf="
            !hideAddressFields &&
            inputSubProject.projectPlacement.address != null
          "
        >
          <div class="under-space">
            <map
              [inputAddress]="inputSubProject.projectPlacement.address"
              [client]="client"
              [fromOldSystem]="fromOldSystem"
              [disabled]="disabled"
              (outputAddress)="setAddress($event)"
              (outputDistance)="setKilometersTo($event)"
              (outputIsValidAddress)="setWasValidAddress($event)"
            ></map>
          </div>
        </div>

        <div *ngIf="!fromOldSystem">
          <mat-card class="top-card mat-elevation-z0 secondary-border-color">
            <div class="d-flex">
              <div class="form-sub-title">
                Heeft u geen foto, gebruik streetview en bezorg ons een
                <span class="secondary-color">screenshot</span>.
              </div>
              <mat-icon
                *ngIf="!sitePhotosAdded"
                class="sitephotos-warning-icon"
                matTooltip="Nog geen afbeelding toegevoegd"
                >report_problem</mat-icon
              >
            </div>
            <div class="site-photo-container">
              <div class="street-view-button">
                <a
                  href="{{ addressPanoId | googleStreetviewLink }}"
                  target="_blank"
                  >Streetview</a
                >
              </div>
            </div>
          </mat-card>

          <textarea-input
            *ngIf="!projectHasIPBoard && !client"
            [title]="'Extra info adres'"
            [placeholder]="'Bv. hoekpand, verkaveling, ...'"
            [initContent]="inputSubProject.projectPlacement.extraInfoAddress"
            [disabled]="disabled"
            (answer)="extraInfoAddressChange($event)"
          ></textarea-input>

          <yes-no
            *ngIf="!projectHasIPBoard"
            [title]="'Wenst u een werfbezoek te laten uitvoeren?'"
            [value]="inputSubProject.projectPlacement.siteVisit"
            [showExtraInstructionsOn]="'Ja'"
            [extraInstructions]="
              'Geef hier opmerkingen over het uit te voeren werfbezoek'
            "
            [inputText]="
              inputSubProject.projectPlacement.extraSiteVisitNeedInfo
            "
            [disabled]="disabled"
            [client]="client"
            (answer)="siteVisitChange($event)"
            (answeredText)="extraSiteVisitNeedInfoChange($event)"
          ></yes-no>

          <yes-no-unknown
            *ngIf="showUndergroundPipeworkQuestion"
            [title]="
              'Ondergrondse leidingen aanwezig (gas, elektriciteit, datakabels, ...)?'
            "
            [value]="inputSubProject.projectPlacement.undergroundPipework"
            [inputText]="
              inputSubProject.projectPlacement.undergroundPipeworkText
            "
            [disabled]="disabled"
            [client]="client"
            (answer)="undergroundPipeworkChanged($event)"
            (answeredText)="undergroundPipeworkTextChanged($event)"
          ></yes-no-unknown>

          <textarea-input
            *ngIf="!projectHasIPBoard && !client"
            [title]="'Extra opmerkingen locatie'"
            [placeholder]="
              'Is de locatie goed bereikbaar (Struiken of takken snoeien, parkeren, markt op het plein, ...)'
            "
            [initContent]="inputSubProject.projectPlacement.extraInfoSite"
            [disabled]="disabled"
            (answer)="extraInfoSiteChange($event)"
          ></textarea-input>

          <file-picker
            *ngIf="showTopdownLocationPhoto"
            [title]="'Afbeelding locatie (bovenaanzicht)'"
            [subtitle]="
              'Voeg hier afbeeldingen toe van het bovenaanzicht van de locatie'
            "
            [inputProjectPlacement]="inputSubProject.projectPlacement"
            [formSection]="'locationTopdown'"
            [client]="client"
            [disabled]="disabled"
          ></file-picker>

          <floor-picker
            *ngIf="showFloorQuestion"
            [(ngModel)]="inputSubProject.projectPlacement.placementFloor"
            (ngModelChange)="placementFloorChange($event)"
            [disabled]="disabled"
            [ipBoardPartForFloorFiltering]="ipBoardPartForFloorFiltering"
            (higherFloorOptionSelected)="higherFloorOptionSelected.emit($event)"
          ></floor-picker>

          <p *ngIf="showAppointmentWarning" class="italics-text">
            Omdat de opdracht hoger dan 1 - 2 moet worden geplaatst, moet u
            ofwel een afspraak aanvragen of aangeven dat er een sleutel moet
            worden afgehaald
          </p>

          <ng-container *ngIf="projectHasIPBoard; else regularAppointment">
            <ip-board-appointment
              [project]="inputProject"
              [projectPlacement]="inputSubProject.projectPlacement"
              [client]="client"
              [disabled]="disabled"
              [nullIsFalse]="true"
              (save)="emit()"
            ></ip-board-appointment>
          </ng-container>
          <ng-template #regularAppointment>
            <yes-no
              [title]="'Afspraak nodig?'"
              [showExtraInstructionsOn]="'Ja'"
              [extraInstructions]="
                'Naam en GSM-nr contactpersoon + uur bereikbaarheid noteren'
              "
              [value]="inputSubProject.projectPlacement.appointment"
              [inputText]="inputSubProject.projectPlacement.needAppointmentInfo"
              [nullIsFalse]="true"
              [nullable]="false"
              [disabled]="disabled"
              [client]="client"
              (answer)="appointmentChange($event)"
              (answeredText)="needAppointmentInfoChange($event)"
            ></yes-no>
          </ng-template>

          <div class="d-flex">
            <yes-no
              [title]="'Sleutel afhalen'"
              [neverShowExtraInstructions]="true"
              [nullable]="false"
              [nullIsFalse]="true"
              [value]="inputSubProject.projectPlacement.collectKey"
              [disabled]="disabled"
              [client]="client"
              (answer)="collectKeyChange($event)"
              class="mr-2"
            ></yes-no>
            <div
              *ngIf="inputSubProject.projectPlacement.collectKey"
              class="left-fifteen-space align-collect-key-from collect-key-from-width"
            >
              <collect-key-from-selector
                [projectPlacement]="inputSubProject.projectPlacement"
                [project]="inputProject"
                (collectKeyFromChanged)="emit()"
              ></collect-key-from-selector>
            </div>
          </div>
          <div
            *ngIf="inputSubProject.projectPlacement.collectKeyFrom === -1"
            class="align-collect-key-extra-info-with-selector"
          >
            <textarea-input
              [placeholder]="'Adres noteren + openingsuren'"
              [initContent]="
                inputSubProject.projectPlacement.collectKeyExtraInfo
              "
              [sensitive]="true"
              (answer)="collectKeyExtraInfoChange($event)"
            ></textarea-input>
          </div>

          <ng-container *ngIf="ipBoardForPoleColor != null">
            <div class="d-flex">
              <div class="strong align-with-pole-color-selector">
                Kleur hout
              </div>
              <div class="left-fifteen-space">
                <mat-form-field appearance="outline">
                  <mat-select
                    matInput
                    placeholder="Kies kleur"
                    [(ngModel)]="ipBoardForPoleColor.poleColor"
                    (ngModelChange)="poleColorChanged()"
                    [compareWith]="compareValueEnum"
                    [disabled]="disabled"
                    required
                  >
                    <mat-option
                      *ngFor="let option of POLE_COLORS_CHOICE_ARRAY"
                      [value]="option"
                      >{{ option.label }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>

          <div class="d-flex">
            <checkbox
              [title]="'Gewenste plaatsingsdatum'"
              [text]="'Het project moet ASAP geplaatst worden'"
              [checked]="inputSubProject.projectPlacement.placeASAP"
              [isDisabled]="disabled"
              (answer)="placeASAP($event)"
            ></checkbox>
            <div class="next-to-checkbox"><b>OF</b></div>
            <mat-form-field class="next-to-checkbox-last" appearance="outline">
              <input
                matInput
                [matDatepickerFilter]="daysFilter"
                [matDatepicker]="placementPicker"
                placeholder="Selecteer een datum"
                [(ngModel)]="
                  inputSubProject.projectPlacement.placementEarliestDate
                "
                [disabled]="disabled"
                (ngModelChange)="placementEarliestDateChange($event)"
              />
              <mat-error *ngIf="dateError">
                Datum mag niet sneller dan 3 werkdagen zijn!
              </mat-error>
              <mat-datepicker-toggle
                matSuffix
                [for]="placementPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #placementPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="fromOldSystem">
          <div class="form-title">
            <div class="form-title-text">Plaatsingsfoto's</div>
          </div>
          <div *ngFor="let product of inputProject.products; let index = index">
            <file-picker
              [title]="
                'Plaatsingsfoto ' +
                getProductPlacementPictureTitle(product, index)
              "
              [inputProduct]="product"
              [formSection]="'execution'"
              [fromOldSystem]="fromOldSystem"
              (answer)="executionAssetsChanged(product)"
              (assetDeleted)="executionAssetsChanged(product)"
            ></file-picker>
          </div>
          <div class="form-title">
            <div class="form-title-text">Uitvoering</div>
          </div>
          <div class="font-weight-bold">Uitvoerdatum</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepickerFilter]="daysFilter"
              [matDatepicker]="picker"
              placeholder="Selecteer een datum"
              [(ngModel)]="inputSubProject.currentExecutionDate"
              (ngModelChange)="oldSystemJobExecutionDateChanged()"
              name="executionDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showExtrasSection">
      <ip-board-extras
        [project]="inputProject"
        [projectPlacement]="inputSubProject.projectPlacement"
        [client]="client"
        (update)="emit()"
      ></ip-board-extras>
    </ng-container>
    <ng-container
      *ngIf="!fromOldSystem && inputProject.collaborative && projectHasIPBoard"
    >
      <div class="upper-space">
        <div class="form-title">
          <div class="form-title-text">Facturatie</div>
        </div>
        <div>
          <span class="strong">Opmerkingen over facturatie hier noteren</span>
          (Verdeelsleutel gezamenlijke opdracht: standaard 50/50)
        </div>
        <div class="smaller-upper-space">
          <textarea-input
            [initContent]="inputSubProject.extraInfoInvoice"
            [client]="client"
            (answer)="extraInfoInvoiceChanged($event)"
          ></textarea-input>
        </div>
      </div>
    </ng-container>
  </div>
</mat-card>
